<template>
  <div class="content-container">
    <ArrivalGuestSearch ref="searchSection" @search="onSearch" />

    <div class="statistic">
      <div class="item">
        <div class="number">{{ numOfRoom }}</div>
        <div class="text">{{ 'Tổng số đặt phòng' }}</div>
      </div>
      <div class="item">
        <div class="number">{{ numOfGuest }}</div>
        <div class="text">{{ 'Tổng số khách' }}</div>
      </div>
    </div>

    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        class="agGrid"
        :auto-select-first-row="false"
        :row-multi-select-with-click="true"
        dom-layout="scroll"
        @cellContextMenu="handleOpenContextMenu"
        @selectionChanged="onSelectionChanged"
      />
      <!-- :is-row-selectable="params => params.data?.sub_booking_group_id" -->
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>

    <div class="button-containers mb-0">
      <button
        class="btn primary small"
        @click="$router.push({ path: '/reservation/new_reservation' })"
      >
        {{ 'Tạo đặt phòng' }}
      </button>
      <button
        class="btn primary small"
        :disabled="
          !(
            selectedRows.length === 2 &&
            selectedRows.every(obj => isHeaderRow(obj)) &&
            selectedRows.every(obj => obj?.booking_type_nm !== 'Đoàn')
          )
        "
        @click="onJoinGroup"
      >
        {{ 'Ghép nhóm' }}
      </button>

      <button
        class="btn primary small"
        :disabled="
          !(
            selectedRows.length > 0 &&
            selectedRows.every(obj => !isHeaderRow(obj)) &&
            selectedRows.every(obj => obj?.room_id)
          )
        "
        @click="onCheckin"
      >
        <!-- @click="dialogCheckinVisible = true" -->
        {{ 'Check-in' }}
      </button>
      <button
        class="btn primary small"
        :disabled="
          !(
            selectedRows.length > 0 &&
            selectedRows.every(obj => !isHeaderRow(obj))
          )
        "
        @click="onCancel"
      >
        {{ 'Hủy đặt phòng' }}
      </button>

      <!-- <button
        :disabled="
          !(
            selectedRows.length === 1 &&
            ['Đoàn', 'Nhóm'].some(
              item => item === selectedRows[0].booking_type_nm
            ) &&
            !isHeaderRow(selectedRows[0])
          )
        "
        class="btn primary small"
        @click="onSetBookingMaster"
      >
        {{ 'Đặt phòng chính' }}
      </button> -->
      <!-- <button
        class="btn primary small"
        :disabled="
          !(
            selectedRows.length === 1 &&
            !isHeaderRow(selectedRows[0]) &&
            'Nhóm' === selectedRows[0].booking_type_nm
          )
        "
        @click="onSeparateFromGroup"
      >
        {{ 'Tách khỏi nhóm' }}
      </button> -->

      <!-- <button
        class="btn primary small"
        :disabled="
          !(selectedRows.length === 1 && !isHeaderRow(selectedRows[0]))
        "
        @click="
          routingBookingInfo = selectedRows[0]
          dialogRoutingVisible = true
        "
      >
        {{ 'Routing' }}
      </button> -->

      <!-- <button class="btn primary small">
        {{ 'Xác nhận' }}
      </button>
      <button class="btn primary small">
        {{ 'Phiếu đăng ký' }}
      </button> -->
      <!-- <button
        class="btn primary small outline"
        :disabled="
          !(selectedRows.length === 1 && !isHeaderRow(selectedRows[0]))
        "
        @click="dialogCancelVisible = true"
      >
        {{ 'Hủy đặt phòng' }}
      </button> -->
    </div>

    <!-- dialog by button -->
    <!-- routing dialog -->
    <!-- <RoutingDialog
      v-model="dialogRoutingVisible"
      :customer-info="routingBookingInfo"
    /> -->
    <!-- cancel booking dialog -->
    <CancelBookingDialog
      v-model="dialogCancelVisible"
      :data="selectedRows"
      @submit="fnGetBookingInfo"
    />
    <!-- Join group dialog -->
    <JoinGroupDialog
      v-model="dialogJoinGroupVisible"
      :data="joinGroupData"
      :group-code="groupCode"
      @resetSearch="onReset"
    />

    <!-- context menu -->
    <nav v-show="ctxMenuState" id="context-menu" class="context-menu">
      <ul class="context-menu__items">
        <li class="context-menu__item" @click="() => getDetailBooking()">
          <a class="context-menu__link" data-action="View"
            ><i class="fa fa-eye"></i>Xem chi tiết
            {{ ctxMenuRow?.booking_type_nm }}</a
          >
        </li>
        <li class="context-menu__item" @click="() => getDetailBooking(true)">
          <a class="context-menu__link" data-action="View"
            ><i class="fa fa-eye"></i>Xem chi tiết
            {{ ctxMenuRow?.booking_type_nm }} trong thẻ mới</a
          >
        </li>
        <li
          class="context-menu__item"
          @click="dialogQuickViewBookingVisible = true"
        >
          <a class="context-menu__link" data-action="View"
            ><i class="fa fa-eye"></i>Xem nhanh các đặt phòng trong
            {{ ctxMenuRow?.booking_type_nm }}</a
          >
        </li>
        <li class="context-menu__item" @click="fnConfirmBooking">
          <a class="context-menu__link" data-action="View">Xác nhận</a>
        </li>

        <li class="context-menu__item" @click="fnregisterForm">
          <a class="context-menu__link" data-action="View">Phiếu đăng ký</a>
        </li>
      </ul>
    </nav>

    <!-- context menu for Single -->
    <nav
      v-show="ctxMenuStateSingle"
      id="context-menu-single"
      class="context-menu"
    >
      <ul class="context-menu__items">
        <li
          v-if="
            ctxMenuRowSingle != null &&
            ['Đoàn', 'Nhóm'].some(
              item => item === ctxMenuRowSingle.booking_type_nm
            ) &&
            !isHeaderRow(ctxMenuRowSingle)
          "
          class="context-menu__item"
          @click="
            selectedRows = [ctxMenuRowSingle]
            onSetBookingMaster()
          "
        >
          <a class="context-menu__link" data-action="View">Đặt phòng chính</a>
        </li>

        <li
          v-if="
            ctxMenuRowSingle != null &&
            !isHeaderRow(ctxMenuRowSingle) &&
            'Nhóm' === ctxMenuRowSingle.booking_type_nm
          "
          class="context-menu__item"
          @click="
            selectedRows = [ctxMenuRowSingle]
            onSeparateFromGroup()
          "
        >
          <a class="context-menu__link" data-action="View">Tách khỏi nhóm</a>
        </li>

        <li
          class="context-menu__item"
          @click="
            if (ctxMenuRowSingle?.room_id) {
              checkinFromCtxMenu = true
              onCheckin()
            } else {
              $message({
                type: 'error',
                message: 'bookingNotAssignedRoomYet'
              })
            }
          "
        >
          <a class="context-menu__link" data-action="View">Check-in</a>
        </li>
        <li
          class="context-menu__item"
          @click="
            selectedRows = [ctxMenuRowSingle]
            dialogCancelVisible = true
          "
        >
          <a class="context-menu__link" data-action="View">Hủy đặt phòng</a>
        </li>
        <li
          class="context-menu__item"
          @click="dialogBookingRoomDetailVisible = true"
        >
          <a class="context-menu__link" data-action="View"
            >Xem chi tiết đặt phòng</a
          >
        </li>

        <li
          v-if="ctxMenuRowSingle != null && ctxMenuRowSingle.room_id != null"
          class="context-menu__item"
          @click="dialogIssueCardVisible = true"
        >
          <a class="context-menu__link" data-action="View"
            >Quản lý khóa phòng</a
          >
        </li>

        <!-- <li class="context-menu__item">
          <a href="#" class="context-menu__link" data-action="View"
            >Xem chi tiết đặt phòng trong thẻ mới</a
          >
        </li> -->

        <!-- <li
          class="context-menu__item"
          @click="
            ctxMenuRow = { ...ctxMenuRowSingle }
            dialogQuickViewBookingVisible = true
          "
        >
          <a href="#" class="context-menu__link" data-action="View"
            >Xem nhanh đặt phòng</a
          >
        </li> -->
      </ul>
    </nav>

    <!-- dialog by context menu -->
    <QuickViewBookingDialog
      v-model="dialogQuickViewBookingVisible"
      :booking="ctxMenuRow"
      @onReloadAfterCheckin="onReloadAfterCheckin"
    />
    <BookingRoomDetailDialog
      v-model="dialogBookingRoomDetailVisible"
      :data="ctxMenuRowSingle"
      @onUpdateBookingRoom="onUpdateBookingRoom"
    />

    <!-- issue card dialog -->
    <IssueCardDialog
      v-model="dialogIssueCardVisible"
      :data="ctxMenuRowSingle"
    />

    <!-- checkin dialog -->
    <!-- <CardReaderDialog v-model="dialogCardReaderVisible" @change="onCheckin" />
    <BookingCheckinDialog
      v-model="dialogCheckinVisible"
      :reservation="ctxMenuRowSingle"
    /> -->
  </div>
</template>

<script>
// import BookingCheckinDialog from './components/BookingCheckinDialog.vue'
// import CardReaderDialog from './components/CardReaderDialog.vue'
// import RoutingDialog from './components/RoutingDialog.vue'
import ArrivalGuestSearch from './components/ArrivalGuestSearch.vue'
import QuickViewBookingDialog from './components/QuickViewBookingDialog.vue'
import CancelBookingDialog from './components/CancelBookingDialog.vue'
import BookingRoomDetailDialog from './components/BookingRoomDetailDialog.vue'
import JoinGroupDialog from './components/JoinGroupDialog.vue'
import IssueCardDialog from './components/IssueCardDialog.vue'

import paginationMixin from '@/mixins/paginationMixin'
import { mapState } from 'vuex'
import {
  getBookingInfo,
  setBookingMaster,
  separateFromGroup,
  getJoinGroup,
  checkin
} from '@/api/reception/reception'
import ctxMenuMixin from '@/mixins/ctxMenuMixin'

export default {
  components: {
    ArrivalGuestSearch,
    QuickViewBookingDialog,
    CancelBookingDialog,
    BookingRoomDetailDialog,
    JoinGroupDialog,
    IssueCardDialog
    // RoutingDialog,
    // BookingCheckinDialog,
    // CardReaderDialog
  },
  mixins: [paginationMixin, ctxMenuMixin],
  data() {
    return {
      loading: false,
      searchParams: {
        firstName: null,
        lastName: null,
        sourceId: null,
        bookingId: null, // ma dat phong
        arriveDate: {
          start: null,
          end: null
        },
        departDate: {
          start: null,
          end: null
        },
        isBooked: true,
        isArriveToDay: null,
        pageSize: 10,
        pageNum: 1,
        orderBy: null,
        orderTp: null
      },
      defaultSearchParams: {
        firstName: null,
        lastName: null,
        sourceId: null,
        bookingId: null, // ma dat phong
        arriveDate: {
          start: null,
          end: null
        },
        departDate: {
          start: null,
          end: null
        },
        isBooked: true,
        isArriveToDay: null,
        pageSize: 10,
        pageNum: 1,
        orderBy: null,
        orderTp: null
      },
      rows: [],
      numOfGuest: 0,
      numOfRoom: 0,

      // context menu
      ctxMenuState: false,
      ctxMenuRow: null,

      ctxMenuStateSingle: false,
      ctxMenuRowSingle: null,

      // open dialog
      dialogQuickViewBookingVisible: false,
      dialogCheckinVisible: false,
      dialogRoutingVisible: false,
      dialogAddRoutingVisible: false,
      dialogCancelVisible: false,
      dialogCardReaderVisible: false,
      dialogBookingRoomDetailVisible: false,
      dialogJoinGroupVisible: false,
      dialogIssueCardVisible: false,

      selectedRows: [],
      routingBookingInfo: null,
      joinGroupData: [],
      groupCode: null,

      // checkin dialog
      checkinFromCtxMenu: false
    }
  },

  computed: {
    // sidebar state:
    ...mapState({
      sidebarState: state => state.app.sidebar.opened
    }),
    columns() {
      return [
        {
          headerName: 'Mã',
          // field: 'sub_booking_group_id',
          valueGetter: params => {
            if (window.isHeaderRow(params)) {
              return `${params.data.booking_type_nm}: ${
                params.data.booking_code || '(N/A)'
              }`
            } else {
              return params.data.recode
            }
          },
          colSpan: params => {
            if (window.isHeaderRow(params)) {
              return 30
            } else {
              return 1
            }
          },
          cellClassRules: {
            'colspan-cell': params => window.isHeaderRow(params)
          },
          width: 150
        },
        {
          headerName: 'Tên khách',
          // field: 'name'
          valueGetter: params =>
            `${params.data?.last_name} ${params.data?.first_name}`
        },
        {
          headerName: 'Số điện thoại',
          field: 'phone_number',
          width: 150
        },
        {
          headerName: 'Nguồn',
          field: 'source_desc',
          minWidth: 270
        },
        {
          headerName: 'Booking ID',
          field: 'sub_booking_group_id',
          width: 100
        },
        {
          headerName: 'Phòng',
          field: 'room_num',
          width: 120
        },
        {
          headerName: 'Khách sạn',
          field: 'hotel_nm'
        },
        {
          headerName: 'Nhân viên Sales',
          field: 'sales_person_nm'
        },
        {
          headerName: 'Ngày khách đến',
          field: 'arrive_date',
          minWidth: 200,
          tooltipField: 'arrive_date'
        },
        {
          headerName: 'Ngày khách đi',
          field: 'depart_date',
          minWidth: 200,
          tooltipField: 'depart_date'
        }
        // {
        //   headerName: 'Giờ khách đến',
        //   field: 'arrive_date'
        // },
        // {
        //   headerName: 'Giờ khách đi',
        //   field: 'depart_date'
        // },
        // {
        //   headerName: 'Đêm',
        //   field: 'num_of_night'
        // },
        // {
        //   headerName: 'Người lớn',
        //   field: 'num_of_guest'
        // },
        // {
        //   headerName: 'Trẻ em',
        //   field: 'child_num'
        // },
        // {
        //   headerName: 'Trạng thái khách',
        //   field: 'status'
        // },
        // {
        //   headerName: 'Ghi chú',
        //   field: 'note'
        // },
        // {
        //   headerName: 'Xác nhận',
        //   field: 'is_confirm'
        // },
        // {
        //   headerName: 'Nội bộ',
        //   field: ''
        // },
        // {
        //   headerName: 'NV kinh doanh',
        //   field: 'sales_person_id'
        // },
        // {
        //   headerName: 'Tên nhân viên kinh doanh',
        //   field: 'sales_person_nm'
        // },
        // {
        //   headerName: 'Dịch vụ đặc biệt',
        //   field: 'special_service_nm'
        // },
        // {
        //   headerName: 'Miễn phí',
        //   field: ''
        // },
        // {
        //   headerName: 'Nhiệm vụ',
        //   field: ''
        // },
        // {
        //   headerName: 'Cảnh báo',
        //   field: ''
        // },
        // {
        //   headerName: 'Bình luận',
        //   field: 'comment'
        // },
        // {
        //   headerName: 'Tin nhắn',
        //   field: 'message'
        // },
        // {
        //   headerName: 'Sinh nhật',
        //   field: 'date_of_birth'
        // },
        // {
        //   headerName: 'Trạng thái đặt phòng',
        //   field: 'booking_room_stat'
        // },
        // {
        //   headerName: 'Mã định danh ngoài',
        //   field: 'external_id'
        // },
        // {
        //   headerName: 'Công ty, đại lý du lịch',
        //   field: 'agent_nm'
        // },
        // {
        //   headerName: 'Tài khoản công nợ',
        //   field: 'debit_acc_nm'
        // },
        // {
        //   headerName: 'Mã nhóm',
        //   field: 'group_code_nm'
        // },
        // {
        //   headerName: 'Email',
        //   field: 'email'
        // }
      ]
    }
  },

  mounted() {
    this.fnGetBookingInfo()

    window.isHeaderRow = params => {
      return !params.data.sub_booking_group_id
    }

    this.contextListener()
    this.clickListener()

    this.keyupListener()
    this.resizeListener()
  },

  // updated() {
  // console.log(document.querySelectorAll('.ag-full-width-row'))
  // console.log('test')
  // this.contextListener()
  // this.clickListener()
  // this.keyupListener()
  // this.resizeListener()
  // },

  beforeDestroy() {
    // remove listener !!!!
  },

  methods: {
    fnregisterForm() {
      const routeData = this.$router.resolve({
        path: '/group/register_form',
        query: {
          id: this.ctxMenuRow?.booking_id || this.ctxMenuRow?.booking_code,
          type: this.ctxMenuRow?.type
        }
      })
      window.open(routeData.href, '_blank')
    },
    fnConfirmBooking() {
      const routeData = this.$router.resolve({
        path: '/confirm_booking'
      })
      window.open(routeData.href, '_blank')
    },
    getDetailBooking(isNewTab = false) {
      if (this.ctxMenuRow?.booking_type_nm === 'Đoàn') {
        if (isNewTab) {
          const routeData = this.$router.resolve({
            path: '/group/new_group_master',
            query: {
              action: 'edit',
              id: this.ctxMenuRow?.booking_id || this.ctxMenuRow?.booking_code
            }
          })
          window.open(routeData.href, '_blank')
        } else {
          this.$router.push({
            path: '/group/new_group_master',
            query: {
              action: 'edit',
              id: this.ctxMenuRow?.booking_id || this.ctxMenuRow?.booking_code
            }
          })
        }
      } else {
        if (isNewTab) {
          const routeData = this.$router.resolve({
            path: '/reservation/new_reservation',
            query: {
              action: 'edit',
              id: this.ctxMenuRow?.booking_id || this.ctxMenuRow?.booking_code
            }
          })
          window.open(routeData.href, '_blank')
        } else {
          this.$router.push({
            path: '/reservation/new_reservation',
            query: {
              action: 'edit',
              id: this.ctxMenuRow?.booking_id || this.ctxMenuRow?.booking_code
            }
          })
        }
      }
    },
    // utils
    isHeaderRow(obj) {
      return !obj?.sub_booking_group_id
    },
    onUpdateBookingRoom() {
      this.dialogBookingRoomDetailVisible = false
      // this.onSearch()
      this.fnGetBookingInfo()
    },
    onReloadAfterCheckin() {
      this.fnGetBookingInfo()
    },
    // handle event
    // pagination
    async onPageChanged(pageNum) {
      this.pageParams.pageNum = pageNum
      await this.fnGetBookingInfo()
    },
    async onPageSizeChange(pageSize) {
      this.pageParams.pageSize = pageSize
      this.pageParams.pageNum = 1
      await this.fnGetBookingInfo()
    },
    onSearch(searchParams) {
      this.searchParams = { ...searchParams }
      this.pageParams.pageNum = 1
      this.fnGetBookingInfo()
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.fnGetBookingInfo()
    },
    onSelectionChanged(selectedRows) {
      // console.log(selectedRows)
      this.selectedRows = selectedRows
    },

    // handle button
    onSetBookingMaster() {
      this.fnSetBookingMaster(this.selectedRows[0].sub_booking_group_id)
    },
    onSeparateFromGroup() {
      this.fnSeparateFromGroup(this.selectedRows[0].sub_booking_group_id)
    },
    onJoinGroup() {
      // this.fnJoinGroup(
      //   this.selectedRows[0].sub_booking_group_id,
      //   this.selectedRows[1].sub_booking_group_id
      // )

      // get data to join
      this.fnGetJoinGroup(
        this.selectedRows[0]?.booking_code,
        this.selectedRows[1]?.booking_code
      )
    },
    onCheckin() {
      this.fnCheckin(
        this.checkinFromCtxMenu
          ? [this.ctxMenuRowSingle?.sub_booking_group_id]
          : this.selectedRows.map(item => item?.sub_booking_group_id)
      )
      this.checkinFromCtxMenu = false
    },
    onCancel() {
      console.log(this.selectedRows)
      const checkSameinBooking = this.selectedRows.every(
        val => val.booking_code === this.selectedRows[0].booking_code
      )
      // console.log(checkSameinBooking)
      if (!checkSameinBooking) {
        this.$message({
          message: 'Không thể hủy đặt phòng khác Nhóm hoặc Đoàn',
          type: 'error'
        })
      } else {
        this.dialogCancelVisible = true
      }
    },
    // handle call api:
    fnGetBookingInfo() {
      const query = {
        ...this.searchParams,
        pageSize: this.pageParams.pageSize,
        pageNum: this.pageParams.pageNum,
        // hydrate date range
        arriveDateFrom: this.searchParams.arriveDate.start,
        arriveDateTo: this.searchParams.arriveDate.end,
        departDateFrom: this.searchParams.departDate.start,
        departDateTo: this.searchParams.departDate.end,
        isInHouse: null,
        isCheckedOutToday: null,
        isBooked: this.searchParams.isArriveToDay ? null : true,
        orderBy: 'arriveGuest'
      }
      delete query.arriveDate
      delete query.departDate
      this.loading = true

      getBookingInfo(query)
        .then(res => {
          if (!res.is_error) {
            this.rows = res.data
            this.numOfGuest = res.num_of_guest
            this.numOfRoom = res.num_of_room
            this.pageParams.pageNum = res.page_num
            this.pageParams.totalPage = Math.ceil(res.total / res.page_size)

            // modify list to custom full width row
            this.rows = res.data.map(item => {
              if (!item?.sub_booking_group_id) {
                return {
                  ...item
                  // isFullWidthRow: true,
                  // name: `${item.booking_type_nm}: ${item.booking_id}`
                }
              } else {
                return item
              }
            })
            this.selectedRows = []
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    // master setting api
    fnSetBookingMaster(bookingId) {
      this.$vxConfirm(
        `Xác nhận đặt phòng chính cho mã đặt phòng ${bookingId}?`,
        () => {
          setBookingMaster({ isMaster: true, bookingId: bookingId })
            .then(data => {
              if (!data.is_error) {
                this.$message({
                  message: data.message,
                  type: 'success'
                })

                this.onReset()
              } else {
                throw new Error(data)
              }
            })
            .catch(error => {
              this.$message({
                message: error.response?.data?.message,
                type: 'error'
              })
            })
            .finally(() => {})
        }
      )
    },
    fnSeparateFromGroup(bookingId) {
      this.$vxConfirm(
        `Xác nhận tách mã đặt phòng ${bookingId} ra khỏi nhóm?`,
        () => {
          separateFromGroup({ bookingId: bookingId })
            .then(data => {
              if (!data.is_error) {
                this.$message({
                  message: data.message,
                  type: 'success'
                })

                this.onReset()
              } else {
                throw new Error(data)
              }
            })
            .catch(error => {
              this.$message({
                message: error.response?.data?.message,
                type: 'error'
              })
            })
            .finally(() => {})
        }
      )
    },
    fnGetJoinGroup(bookingCode1, bookingCode2) {
      if (this.selectedRows[0].type === this.selectedRows[1].type) {
        if (this.selectedRows[0].type === '3') {
          this.groupCode = null // the two are khach le
        }
        if (this.selectedRows[0].type === '1') {
          this.groupCode = this.selectedRows[0]?.booking_code // the two are nhom
        }
      } else {
        this.selectedRows[0].type === '1'
          ? (this.groupCode = this.selectedRows[0]?.booking_code)
          : (this.groupCode = this.selectedRows[1]?.booking_code)
        // if (this.selectedRows[0].type === '1') {
        //   this.groupCode = this.selectedRows[0]?.booking_code
        // }
        // if (this.selectedRows[1].type === '1') {
        //   this.groupCode = this.selectedRows[1]?.booking_code
        // }
      }
      getJoinGroup({ bookingCode1, bookingCode2 })
        .then(data => {
          if (!data.is_error) {
            this.joinGroupData = [...data.data]
            this.dialogJoinGroupVisible = true
          } else {
            throw new Error(data)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },
    // fnJoinGroup(bookingId1, bookingId2) {
    //   this.$vxConfirm(
    //     `Xác nhận ghép mã đặt phòng ${bookingId1} và ${bookingId2}?`,
    //     () => {
    //       joinGroup({
    //         bookingGroupId1: bookingId1,
    //         bookingGroupId2: bookingId2
    //       })
    //         .then(data => {
    //           if (!data.is_error) {
    //             this.$message({
    //               message: data.message,
    //               type: 'success'
    //             })

    //             this.onReset()
    //           } else {
    //             throw new Error(data)
    //           }
    //         })
    //         .catch(error => {
    //           console.log(error)
    //           this.$message({
    //             message: error.response?.data?.message,
    //             type: 'error'
    //           })
    //         })
    //         .finally(() => {})
    //     }
    //   )
    // },
    fnCheckin(data) {
      checkin(data)
        .then(data => {
          if (!data.is_error) {
            this.$message({
              message: data.message,
              type: 'success'
            })

            this.onReset()
          } else {
            // throw new Error(data)
            this.$message({
              message: data?.message,
              type: 'error'
            })
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },

    // handle context menu:
    // listener
    contextListener() {
      // apply only be call in updated()
      // document.querySelectorAll('.ag-full-width-row').forEach(item => {
      //   item.addEventListener('contextmenu', e => {
      //     console.log(e)
      //     // open context menu
      //     this.toggleMenuOn()
      //     this.positionMenu(e)

      //     e.preventDefault()
      //   })
      // })

      document.addEventListener('contextmenu', e => {
        const row = this.clickInsideCtxMenu(e, 'agGrid')
        if (
          row &&
          (e.target.classList.contains('ag-cell') ||
            e.target.classList.contains('ag-row'))
        ) {
          if (e.target.classList.contains('colspan-cell')) {
            this.positionMenu(e, '#context-menu')
            // open contextmenu
            this.ctxMenuState = true
            this.ctxMenuStateSingle = false
          } else {
            this.positionMenu(e, '#context-menu-single')
            // open contextmenu
            this.ctxMenuStateSingle = true
            this.ctxMenuState = false
          }

          e.preventDefault()
        } else {
          this.ctxMenuState = false
          this.ctxMenuStateSingle = false
        }
      })
    },
    clickListener() {
      document.addEventListener('click', e => {
        // const clickedElIsItem = this.clickInsideCtxMenu(
        //   e,
        //   'context-menu__link'
        // )

        // if (clickedElIsItem) {
        //   e.preventDefault()
        //   // handle event in context menu
        //   console.log('you click data', this.ctxMenuRow)
        //   this.dialogQuickViewBookingVisible = true
        // }
        // e.stopImmediatePropagation()
        // e.stopPropagation()
        // this.ctxMenuState = false

        this.ctxMenuState = false
        this.ctxMenuStateSingle = false
      })
    },

    // for ag grid
    handleOpenContextMenu(event) {
      if (!event.data?.sub_booking_group_id) {
        this.ctxMenuRow = event.data
      } else {
        this.ctxMenuRowSingle = event.data
        this.ctxMenuRow = event.data
      }
    },
    keyupListener() {
      window.onkeyup = e => {
        if (e.keyCode === 27) {
          this.ctxMenuState = false
          this.ctxMenuStateSingle = false
        }
      }
    },
    resizeListener() {
      window.onresize = e => {
        this.ctxMenuState = false
        this.ctxMenuStateSingle = false
      }
    },

    openInNewTab() {
      const routeData = this.$router.resolve({
        path: '/reservation/new_reservation',
        query: {
          action: 'edit',
          id: this.ctxMenuRow?.booking_id || this.ctxMenuRow?.booking_code
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss">
.statistic {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0 0 1rem;

  gap: 30px;
  .item {
    display: flex;
    align-items: center;
    gap: 8px;

    .number {
      padding: 5px 10px;
      font-size: 14px;
      font-weight: 600;
      border-radius: 20px;
      color: #fff;
      background: pink;
    }
    .text {
      color: green;
      font-size: 14px;
      font-weight: 600;
      // text-transform: uppercase;
    }
    &:nth-child(1) {
      .number {
        background: #6c757d;
      }
    }
    &:nth-child(2) {
      .number {
        background: #b4adb5;
      }
    }
  }
}

.ag-row:has(.colspan-cell) {
  background-color: #edf5f1;
  border-radius: 5px;
  font-weight: bold;
}

/* context menu */

.context-menu {
  // display: none;
  position: absolute;
  z-index: 10;
  padding: 8px 0;
  width: 320px;
  background-color: #fff;
  border: solid 1px #dfdfdf;
  box-shadow: 1px 1px 2px #cfcfcf;
  font-size: 14px;
}

.context-menu--active {
  display: block;
}

.context-menu__items {
  list-style: none;
  margin: 0;
  padding: 0;
}

.context-menu__item {
  display: block;
  margin-bottom: 4px;
}

.context-menu__item:last-child {
  margin-bottom: 0;
}

.context-menu__link {
  display: block;
  padding: 4px 12px;
  color: #25a366;
  text-decoration: none;
}

.context-menu__link:hover {
  color: #fff;
  background-color: #25a366;
}
</style>
